
export default function TestimonialsStats() {
  const stats = [
    {
      icon: 'fa-users',
      number: '500+',
      label: 'Happy Customers',
      color: 'bg-amber-500'
    },
    {
      icon: 'fa-star',
      number: '4.9/5',
      label: 'Average Rating',
      color: 'bg-sky-500'
    },
    {
      icon: 'fa-home',
      number: '750+',
      label: 'Projects Completed',
      color: 'bg-amber-500'
    },
    {
      icon: 'fa-award',
      number: '18+',
      label: 'Years Experience',
      color: 'bg-sky-500'
    },
  ];

  return (
    <section className="py-16 px-6 bg-beige-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className={`w-16 h-16 flex items-center justify-center mx-auto mb-4 ${stat.color} rounded-full`}>
                <i className={`fas ${stat.icon} text-2xl text-white`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-bold text-slate-900 mb-2">
                {stat.number}
              </div>
              <div className="text-sm text-slate-600">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
